import Note, { enharmonic } from '@tonaljs/note'
import ChordType from '@tonaljs/chord-type'
import ScaleDictionary from '@tonaljs/scale-dictionary'

import Scale from '@tonaljs/scale'
import ChordDetect from '@tonaljs/chord-detect'
import Chord from '@tonaljs/chord'
import { ROMAN_DEGREES } from './constants'

export const notes = Scale.get('C chromatic').notes

const getAllNotes = () => {

	const allNotesBasicEnharmonics = new Set(notes.flatMap(note => [note, enharmonic(note)]))

	// Need to add those two
	allNotesBasicEnharmonics.add('Cb')
	allNotesBasicEnharmonics.add('Fb')
	allNotesBasicEnharmonics.add('B#')
	allNotesBasicEnharmonics.add('E#')

	return Array.from(allNotesBasicEnharmonics).flatMap(note => note.length === 1 ? note : [note, note + note[1]])
}

export const allNotes = getAllNotes()

export const allChords = ChordType.all()


export const getAllScales = () => ScaleDictionary.entries().flatMap(scaleDef => notes.map(keyName => Scale.get(`${keyName} ${scaleDef.name}`)))

export const areNoteEnharmonic = (n1: string, n2: string) =>
	Note.enharmonic(n1) === n2 || Note.enharmonic(n1) === Note.enharmonic(n2) ||
	n1 === n2 || n1 === Note.enharmonic(n2)

export const compareNotes = (n1: string, n2: string) => {
	const i1 = notes.findIndex(n => areNoteEnharmonic(n, n1))
	const i2 = notes.findIndex(n => areNoteEnharmonic(n, n2))
	return i1 === i2 ? 0 : i1 < i2 ? 1 : -1
}

const extendedChords = {
	'seventh': '7',
	'ninth': '9',
	'thirteenth': '13'
}

const aliasesWhitelist = ['2', '6']

const trimAliases = (aliases: string[]) => aliases.map((alias: string) => alias.replaceAll(/maj|min|M|m/g, ''))

export const getDegreeNotation = (chord: any, scale: any) => {
	const scale2 = Scale.get(scale)

	const degreeIndex = scale2.notes.findIndex((n: string) => n === chord.notes[0])// TODO : enharmonic usefuls ? since this is controlled only, chord.tonic not working for F- (is F- ... ?)

	if (degreeIndex === -1) return

	let degree = ROMAN_DEGREES[degreeIndex]

	if (chord.quality === 'Minor' || chord.quality === 'Diminished')
		degree = degree.toLowerCase()
	
	let type = ''

	// if (chord.type.includes('seventh'))
	// 	type = '7'
	// else
	// if (chord.quality === 'Diminished')// Add 7 if it's a seventh
	// 	type = trimAliases(chord.aliases).reduce((a: string, b: string) => a.length <= b.length ? a : b)
	// else
	//chord.quality === 'Major' &&  && chord.quality !== 'Minor' && )
		if (!(chord.notes.length === 3 && (chord.quality === 'Major' || chord.quality === 'Minor'))) {// exclude triads
			if (chord.currentName && chord.aliases.includes(chord.currentName.slice(chord.notes[0].length)))// TODO : might not work with inversed chords
				type = chord.currentName.slice(chord.notes[0].length)
			else
				type = trimAliases(chord.aliases.filter((alias: string) => !aliasesWhitelist.includes(alias))).reduce((a: string, b: string) => a.length <= b.length ? a : b)
		}

	return degree + (type.length > 0 ? ' ' + type : '')
}

// options { type: [fifth, triad, seventh, ...] }

// PROBLEM : B fifth doesnt exist in C major scale
export const getScaleChords = (scale: string, options: any = { type: 'triad' }) => {
	const { type } = options
	
	const degrees = [0, 1, 2, 3, 4, 5, 6]
	
	const scale2 = Scale.get(scale)

	// console.log({ scale2 })

	const modesNames = Scale.modeNames(scale2.name)

	// console.log({ modesNames })

	const scales = degrees.map((d) => Scale.get(modesNames[d][0] + ' ' + modesNames[d][1]))

	const chords = scales.map((scale: any) => {
		// type = triad
		// TODO : add other chord type/quality
		const notes =
			type === 'fifth' ? [scale.notes[0], scale.notes[4]] :
			type === 'triad' ? [scale.notes[0], scale.notes[2], scale.notes[4]] :
			type === 'seventh' ? [scale.notes[0], scale.notes[2], scale.notes[4], scale.notes[6]]
			// TODO :
			// type === 'eleventh' ? [scale.notes[0], scale.notes[2], scale.notes[4], scale.notes[6]] :
			// type === 'thirteenth' ? [scale.notes[0], scale.notes[2], scale.notes[4], scale.notes[6]]
				: []

		return ChordDetect.detect(notes)
	}).map((chordsDetect: any) => Chord.get(chordsDetect[0])).filter((c: any) => !c.empty).map((c: any) => {
		// console.log({ c })
		return {
			currentName: c.notes[0] + trimAliases(c.aliases).reduce((a: string, b: string) => a.length <= b.length ? a : b),
			degreeName: getDegreeNotation(c, scale),
			...c,
		}
	})

	return chords
}

const types = ['fifth', 'triad', 'seventh']

export const getScaleAllChords = (scale: string) => {
	const allChords: any = {}

	for (const type of types) {
		allChords[type] = getScaleChords(scale, { type })
	}

	return allChords
}

// TODO : more precise analyse (sus4, b5, etc)
export const getChordProperties = (chord: any) => {
	const properties: any = {}

	if (chord.notes.length === 2)
		properties.type = 'fifth'
	else if (chord.notes.length === 3)
		properties.type = 'triad'
	else if (chord.notes.length === 4)// Might not be exact
		properties.type = 'seventh'
	// TODO :
	// else if (chord.notes.length === 5)// Might not be exact
	// 	properties.type = 'eleventh'
	// else if (chord.notes.length === 6)// Might not be exact
	// 	properties.type = 'thirteenth'// maybe dominant thirteeth
	
	return properties
}

export const getChordDegreeIndex = (chord: any) =>
	ROMAN_DEGREES.findIndex((d: string) => chord.degreeName && d === chord.degreeName.split(' ')[0].toUpperCase())

export const getChordDegreeType = (chord: any) => {
	const type = chord.degreeName.split(' ')[1]

	if (type === undefined)
		return ''
	else if (type === '7')
		return '7'
	else
		return ''
}